import { nanoid } from "nanoid";

export const PUBLIC_ID_LENGTH = 21;

export const PUBLIC_ID_ALPHABET =
  "_-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

const PUBLIC_ID_REGEX = /^[A-Za-z0-9_-]{21}$/;

export function generatePublicId(): string {
  return nanoid(PUBLIC_ID_LENGTH);
}

export function isPublicId(value: unknown): value is string {
  return typeof value === "string" && PUBLIC_ID_REGEX.test(value);
}
